import React from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';
import { Link } from 'react-router';
import {
  AssignedIconWithTooltip,
  WatchedIconWithTooltip,
} from 'chameleon/ui-stack/ui/assessments/icons-with-tooltip';

const RelatedVideoItem = (props) => {
  const {
    id,
    displayName,
    displayAssignedIcon,
    isAssigned,
    isWatched,
    previewPath,
  } = props;

  return (
    <div className="ft-rv-item">
      <Link
        className="ft-rv-video-title flex-vertical-align"
        to={previewPath}
        data-test-related-video-item-header
      >
        {displayName}
      </Link>
      <div className="flex items-center ml-0.8 gap-3">
        {isAssigned && displayAssignedIcon && (
          <AssignedIconWithTooltip target={`related-video-assigned-${id}`} />
        )}
        {isWatched && (
          <WatchedIconWithTooltip target={`related-video-watched-${id}`} />
        )}
      </div>
    </div>
  );
};

RelatedVideoItem.displayName = 'RelatedVideoItem';

RelatedVideoItem.propTypes = {
  displayName: PropTypes.string.isRequired,
  displayAssignedIcon: PropTypes.bool.isRequired,
  isAssigned: PropTypes.bool,
  isWatched: PropTypes.bool,
  userClassIds: PropTypes.array,
  previewPath: PropTypes.string.isRequired,
};

RelatedVideoItem.defaultProps = {
  isAssigned: false,
  isWatched: false,
  userClassIds: [],
};

export default connectLean({
  mapState(state, ownProps) {
    const { savedClasses, withWatchedVideo: isWatched } = state;
    const { userClassIds } = ownProps;

    return {
      isAssigned: (savedClasses || []).some((assignedClassId) =>
        userClassIds.includes(assignedClassId),
      ),
      isWatched,
    };
  },
})(RelatedVideoItem);
